import axiosHttp from 'axios'

axiosHttp.defaults.withCredentials = true
// axiosHttp.defaults.baseURL = window.App.$store.state.apiUrl
axiosHttp.defaults.crossdomain = true

export const axios = axiosHttp
